(function () {
  'use strict';

  // 二重読み込み防止
  if (window.__variantGuardLoaded) return;
  window.__variantGuardLoaded = true;

  // ===== 設定 =====
  var LABEL_LOADING = '選択中';
  var LOCK_MS = 1500;

  // ============================================================
  // ロック表示用のCSS（1回だけ挿入）
  // ============================================================
  function injectStyle() {
    if (document.getElementById('vg-style')) return;
    var s = document.createElement('style');
    s.id = 'vg-style';
    s.textContent =
      '.vg-locked{position:relative!important;pointer-events:none!important;color:transparent!important;}' +
      '.vg-locked>*:not(.vg-guard-overlay){visibility:hidden!important;}' +
      '.vg-guard-overlay{position:absolute;inset:0;display:flex;align-items:center;' +
      'justify-content:center;pointer-events:auto;opacity:0;' +
      'animation:vg-fade .2s ease-out .18s forwards;}' +
      '.vg-spinner{width:1.1em;height:1.1em;border-radius:50%;box-sizing:border-box;' +
      'border:2px solid currentColor;border-top-color:transparent;' +
      'animation:vg-spin .6s linear infinite;}' +
      '@keyframes vg-fade{to{opacity:1}}' +
      '@keyframes vg-spin{to{transform:rotate(360deg)}}' +
      '@media (prefers-reduced-motion:reduce){.vg-spinner{animation:none;opacity:.6}}';
    (document.head || document.documentElement).appendChild(s);
  }

  // ============================================================
  // 対象判定：テーマ標準のメイン商品フォームだけを相手にする
  // ============================================================
  function isBundleContext(el) {
    return !!(el && el.closest && el.closest('[class*="bundle"], [id*="bundle"]'));
  }

  function isTargetForm(form) {
    if (!form) return false;
    var action = form.getAttribute('action') || '';
    var cls    = form.getAttribute('class')  || '';
    var fid    = form.getAttribute('id')     || '';
    if (action.indexOf('/cart/add') === -1) return false;
    if (cls.indexOf('main-product-form') === -1) return false;
    if (cls.indexOf('installment') !== -1) return false;
    if (fid.indexOf('template--') === -1) return false;
    if (isBundleContext(form)) return false;
    return true;
  }

  function getPrefixFromFieldset(fs) {
    if (!fs || !fs.id) return null;
    var m = fs.id.match(/^fieldset-(.*?)-product-/);
    return m ? m[1] : null;
  }

  function getPrefixForForm(form) {
    var fid = form.getAttribute('id') || '';
    var found = null;
    document.querySelectorAll('fieldset[id^="fieldset-"]').forEach(function (fs) {
      var p = getPrefixFromFieldset(fs);
      if (p && !found && fid.indexOf(p) !== -1) found = p;
    });
    return found;
  }

  function getTargetForms(prefix) {
    if (!prefix) return [];
    return Array.prototype.slice.call(
      document.querySelectorAll('form[action*="/cart/add"]')
    ).filter(function (f) {
      return isTargetForm(f) && (f.getAttribute('id') || '').indexOf(prefix) !== -1;
    });
  }

  function getSelectedOptions(prefix) {
    var result = {};
    if (!prefix) return result;
    document.querySelectorAll('fieldset[id^="fieldset-"]').forEach(function (fs) {
      if (getPrefixFromFieldset(fs) !== prefix) return;
      var checked = fs.querySelector('input[type="radio"][data-option-value]:checked');
      if (!checked) return;
      var pos = checked.getAttribute('data-option-position');
      var val = checked.getAttribute('data-option-value');
      if (pos && val !== null) result[pos] = String(val).trim();
    });
    return result;
  }

  function findVariant(variants, selected) {
    var positions = Object.keys(selected);
    if (!positions.length) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < positions.length; j++) {
        var themeVal = v['option' + positions[j]];
        if (themeVal === undefined || String(themeVal).trim() !== selected[positions[j]]) {
          ok = false; break;
        }
      }
      if (ok) return v;
    }
    return null;
  }

  // ============================================================
  // 度数データの先読み（商品ページのみ・1回だけ）
  // ============================================================
  var VARIANTS = [];

  function preloadVariants() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path.indexOf('/products/') === -1) return;
    fetch(path + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && d.variants) {
          VARIANTS = d.variants;
          console.log('[variant-guard] 度数データ読み込み完了:', VARIANTS.length + '件');
        }
      })
      .catch(function () {
        console.warn('[variant-guard] 度数データ読み込み失敗（通常動作のまま続行）');
      });
  }

  // ============================================================
  // STEP1: 度数変更中、ボタンの上にフタを被せる
  //        ボタンの中身・disabled属性には一切触れない
  // ============================================================
  function unlockButton(btn) {
    btn.classList.remove('vg-locked');
    btn.removeAttribute('aria-busy');
    if (btn._vgOverlay && btn._vgOverlay.parentNode) {
      btn._vgOverlay.parentNode.removeChild(btn._vgOverlay);
    }
    btn._vgOverlay = null;
  }

  function lockButton(form) {
    var btn = form.querySelector('[type="submit"], button[name="add"]');
    if (!btn) return;

    if (btn._vgTimer) clearTimeout(btn._vgTimer);

    if (!btn._vgOverlay) {
      var color = window.getComputedStyle(btn).color;
      var ov = document.createElement('span');
      ov.className = 'vg-guard-overlay';
      ov.style.color = color;
      ov.setAttribute('aria-label', LABEL_LOADING);

      var sp = document.createElement('span');
      sp.className = 'vg-spinner';
      ov.appendChild(sp);

      btn.appendChild(ov);
      btn._vgOverlay = ov;
      btn.classList.add('vg-locked');
      btn.setAttribute('aria-busy', 'true');
    }

    btn._vgTimer = setTimeout(function () {
      btn._vgTimer = null;
      unlockButton(btn);
    }, LOCK_MS);
  }

  function onChange(e) {
    var radio = e.target;
    if (!radio || !radio.matches) return;
    if (!radio.matches('input[type="radio"][data-option-value]')) return;
    if (isBundleContext(radio)) return;
    var prefix = getPrefixFromFieldset(radio.closest('fieldset'));
    getTargetForms(prefix).forEach(lockButton);
  }

  // ============================================================
  // STEP2: クリック直前にIDのズレを補正（通信なし・中断なし）
  // ============================================================
  function onClick(e) {
    try {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('button[name="add"], button[type="submit"], input[type="submit"]');
      if (!btn) return;

      var form = btn.closest('form');
      if (!isTargetForm(form)) return;
      if (!VARIANTS.length) return;

      var correct = findVariant(VARIANTS, getSelectedOptions(getPrefixForForm(form)));
      if (!correct) return;

      var idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.value !== String(correct.id)) {
        console.log('[variant-guard] IDを補正:', idInput.value, '→', correct.id, '(' + correct.title + ')');
        idInput.value = correct.id;
      }
    } catch (err) {
      console.warn('[variant-guard] 補正処理をスキップ', err);
    }
  }

  // ============================================================
  // 起動
  // ============================================================
  function init() {
    injectStyle();
    preloadVariants();
    document.addEventListener('change', onChange);
    document.addEventListener('click', onClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();